import React from "react";
import ArtifactsPopup from "../component/app/insurance/card/ArtifactsPopup";

const KnowledgeHub = () => {
  return (
    <>
      <ArtifactsPopup />
    </>
  );
};

export default KnowledgeHub;
